<template>
  <div class="page">
    <el-form
      size="small"
      :inline="true"
      class="query-form"
      ref="searchForm"
      :model="searchForm"
      @keyup.enter.native="refreshList()"
      @submit.native.prevent
    >
      <!-- 搜索框-->
      <el-form-item prop="firstName" v-if="activeName == '1'">
        <el-input size="small" v-model="searchForm.firstName" placeholder="姓" clearable></el-input>
      </el-form-item>
      <el-form-item prop="lastName" v-if="activeName == '1'">
        <el-input size="small" v-model="searchForm.lastName" placeholder="名" clearable></el-input>
      </el-form-item>
      <el-form-item prop="fullName" v-if="activeName == '2'">
        <el-input size="small" v-model="searchForm.fullName" placeholder="全名" clearable></el-input>
      </el-form-item>
      <el-form-item prop="message" v-if="activeName == '1'">
        <el-input size="small" v-model="searchForm.message" placeholder="信息" clearable></el-input>
      </el-form-item>
      <el-form-item prop="email">
        <el-input size="small" v-model="searchForm.email" placeholder="邮箱" clearable></el-input>
      </el-form-item>
      <el-form-item prop="projectType" v-if="activeName == '2'">
        <el-select v-model="searchForm.projectType" placeholder="项目类型"  class="width205">
          <el-option
            v-for="item in $dictUtils.getDictList('cec_project_type')"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="projectStartTime" v-if="activeName == '2'">
        <el-select v-model="searchForm.projectStartTime" clearable placeholder="期望项目开始日期"  class="width205">
          <el-option
            v-for="item in $dictUtils.getDictList('cec_project_start_time')"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="projectBudget" v-if="activeName == '2'">
        <el-select v-model="searchForm.projectBudget" clearable placeholder="项目预算" style="width: 180px">
          <el-option
            v-for="item in $dictUtils.getDictList('cec_project_budget')"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item prop="status">
            <el-select
                v-model="searchForm.statusIn"
                clearable
                placeholder="状态"
                style="width: 250px"
                :multiple="true"
              >
                <el-option
                  v-for="item in $dictUtils.getDictList('cec_status')"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
      </el-form-item>
      <el-form-item prop="isRead">
        <el-select v-model="searchForm.isRead" clearable placeholder="已读未读" style="width: 180px">
          <el-option
            v-for="item in isReadList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="refreshList()" size="small" icon="el-icon-search">查询</el-button>
        <el-button @click="resetSearch()" size="small" icon="el-icon-refresh-right">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="bg-white top">
      <div style="height: calc(100% - 40px);">
        <el-tabs v-model="activeName" @tab-click="handleClick" style="height: 100%;">
          <!-- <el-tab-pane label="联系我们" name="1">
            <vxe-toolbar :refresh="{query: refreshList}" import export print custom>
              <template #buttons>
                <el-button
                  v-if="hasPermission('unmcontactus:cecUnmContactUs:del')"
                  type="danger"
                  size="small"
                  icon="el-icon-delete"
                  @click="del()"
                  :disabled="$refs.cecUnmContactUsTable && $refs.cecUnmContactUsTable.getCheckboxRecords().length === 0"
                  plain
                >删除</el-button>
              </template>
              <template #tools>
                <vxe-button
                  type="default"
                  title="下载导入模板"
                  v-if="hasPermission('unmcontactus:cecUnmContactUs:import')"
                  class="el-icon-document m-r-12"
                  @click="downloadTpl()"
                  circle
                ></vxe-button>
              </template>
            </vxe-toolbar>

            <vxe-table
              border="full"
              auto-resize
              resizable
              :loading="loading"
              size="small"
              ref="cecUnmContactUsTable"
              show-header-overflow
              show-overflow
              highlight-hover-row
              :menu-config="{}"
              :print-config="{}"
              :import-config="{
            importMethod: importMethod,
                types: ['csv', 'xls', 'xlsx'],
                remote: true,
            }"
              :export-config="{
                remote: true,
                filename: `联系我们管理数据${moment(new Date()).format(
            		'YYYY-MM-DD'
                )}`,
                sheetName: '联系我们管理数据',
                exportMethod: exportMethod,
                types: ['xlsx'],
                modes: ['current', 'selected', 'all'],
            }"
              @sort-change="sortChangeHandle"
              :sort-config="{remote:true}"
              :data="dataList"
              :checkbox-config="{}"
            >
              <vxe-column type="checkbox" width="40px"></vxe-column>
              <vxe-column type="seq" width="50" align="center"></vxe-column>
              <vxe-column field="email" align="center" sortable title="邮箱">
                <template slot-scope="scope">
                  <el-link
                    type="primary"
                    :underline="false"
                    v-if="hasPermission('unmcontactus:cecUnmContactUs:view')"
                    @click="view(scope.row.id,'1')"
                  >{{scope.row.email}}</el-link>
                  <span v-else>{{scope.row.email}}</span>
                </template>
              </vxe-column>
              <vxe-column field="ipAddress" align="center" width="150" sortable title="ip"></vxe-column>
              <vxe-column field="firstName" align="center" sortable title="姓"></vxe-column>
              <vxe-column field="lastName" align="center" sortable title="名"></vxe-column>
              <vxe-column field="message" align="center" title="信息"></vxe-column>
              <vxe-column field="createDate" align="center" width="150" sortable title="发送时间"></vxe-column>
              <vxe-column field="status" align="center" sortable width="80" title="状态">
                <template slot-scope="scope">
                  <el-tag
                    :color="scope.row.status == '0' ? '#ffff00':'#92d050'"
                    size="small"
                    style="color:black"
                  >{{ scope.row.status == '0' ? '未处理' : '已处理' }}</el-tag>
                </template>
              </vxe-column>
              <vxe-column field="isRead" align="center" sortable width="120" title="已读未读">
                <template slot-scope="scope">
                  <el-tag
                    :color="scope.row.isRead == '0' ? '#ffff00':'#92d050'"
                    size="small"
                    style="color:black"
                  >{{ scope.row.isRead == '0' ? '未读' : '已读' }}</el-tag>
                </template>
              </vxe-column>
              <vxe-column field="remarks" sortable align="center" title="内部备注"></vxe-column>
            </vxe-table>
          </el-tab-pane> -->
          <el-tab-pane label="免费设计咨询" name="2">
            <vxe-toolbar :refresh="{query: refreshList}" import export print custom>
              <template #buttons>
                <!-- <el-button v-if="hasPermission('unmcontactus:cecUnmContactUs:add')" type="primary" size="small" icon="el-icon-plus" @click="add()">新建</el-button> -->
                <!-- <el-button v-if="hasPermission('unmcontactus:cecUnmContactUs:edit')" type="warning" size="small" icon="el-icon-edit-outline" @click="edit()" :disabled="$refs.cecUnmContactUsTable && $refs.cecUnmContactUsTable.getCheckboxRecords().length !== 1" plain>修改</el-button> -->
                <el-button
                  v-if="hasPermission('unmcontactus:cecUnmContactUs:del')"
                  type="danger"
                  size="small"
                  icon="el-icon-delete"
                  @click="del('2')"
                  :disabled="$refs.cecUnmContactUsTable2 && $refs.cecUnmContactUsTable2.getCheckboxRecords().length === 0"
                  plain
                >删除</el-button>
              </template>
              <template #tools>
                <vxe-button
                  type="default"
                  title="下载导入模板"
                  v-if="hasPermission('unmcontactus:cecUnmContactUs:import')"
                  class="el-icon-document m-r-12"
                  @click="downloadTpl()"
                  circle
                ></vxe-button>
              </template>
            </vxe-toolbar>

            <vxe-table
              border="full"
              auto-resize
              resizable

              :loading="loading"
              size="small"
              ref="cecUnmContactUsTable2"
              show-header-overflow
              show-overflow
              highlight-hover-row
              :menu-config="{}"
              :print-config="{}"
              :import-config="{
            importMethod: importMethod,
                types: ['csv', 'xls', 'xlsx'],
                remote: true,
            }"
              :export-config="{
                remote: true,
                filename: `联系我们管理数据${moment(new Date()).format(
            		'YYYY-MM-DD'
                )}`,
                sheetName: '联系我们管理数据',
                exportMethod: exportMethod,
                types: ['xlsx'],
                modes: ['current', 'selected', 'all'],
            }"
              @sort-change="sortChangeHandle"
              :sort-config="{remote:true}"
              :data="dataList"
              :checkbox-config="{}"
            >
              <vxe-column type="checkbox" width="40px"></vxe-column>
              <vxe-column type="seq" width="50" align="center"></vxe-column>
              <vxe-column field="email" align="center" sortable title="邮箱">
                <template slot-scope="scope">
                  <!-- <el-link  type="primary" :underline="false" v-if="hasPermission('unmcontactus:cecUnmContactUs:edit')" @click="edit(scope.row.id)">{{scope.row.email}}</el-link> -->
                  <el-link
                    type="primary"
                    :underline="false"
                    v-if="hasPermission('unmcontactus:cecUnmContactUs:view')"
                    @click="view(scope.row.id,'2')"
                  >{{scope.row.email}}</el-link>
                  <span v-else>{{scope.row.email}}</span>
                </template>
              </vxe-column>
              
              <vxe-column field="phone" align="center" width="150" sortable title="联系电话"></vxe-column>
              <vxe-column field="fullName" align="center" sortable title="全名"></vxe-column>
              <vxe-column field="projectTypeName" align="center" sortable title="项目类型"></vxe-column>
              <vxe-column field="projectStartTimeName" align="center" sortable title="期望项目开始日期"></vxe-column>
              <vxe-column field="projectBudgetName" align="center" sortable title="项目预算"></vxe-column>
              <vxe-column field="ipAddress" align="center" width="150" sortable title="ip"></vxe-column>
              <vxe-column field="createDate" align="center" width="150" sortable title="客户填写时间"></vxe-column>
              <vxe-column field="status" align="center" sortable width="80" title="状态">
                <template slot-scope="scope">
                  <el-tag
                    :color="scope.row.status == '0' ? '#ffff00': scope.row.status == '1' ? '#ddebf7':'#92d050'"
                    size="small"
                    style="color:black"
                  >{{ scope.row.status == '0' ? '未处理' : scope.row.status == '1' ? '处理中' :  '已处理' }}</el-tag>
                </template>
              </vxe-column>
              <vxe-column field="isRead" align="center" sortable width="120" title="已读未读">
                <template slot-scope="scope">
                  <el-tag
                    :color="scope.row.isRead == '0' ? '#ffff00':'#92d050'"
                    size="small"
                    style="color:black"
                  >{{ scope.row.isRead == '0' ? '未读' : '已读' }}</el-tag>
                </template>
              </vxe-column>
              <vxe-column field="sendEmailTime" align="center" width="180" sortable title="上一次发送邮件时间"></vxe-column>
              <vxe-column field="remarks" sortable align="center" title="内部备注"></vxe-column>
              <!-- <vxe-column
        fixed="right"
        align="center"
        width="200"
        title="操作">
        <template  slot-scope="scope">
          <el-button v-if="hasPermission('unmcontactus:cecUnmContactUs:view')" type="text" icon="el-icon-view" size="small" @click="view(scope.row.id)">查看</el-button>
          <el-button v-if="hasPermission('unmcontactus:cecUnmContactUs:edit')" type="text" icon="el-icon-edit" size="small" @click="edit(scope.row.id)">修改</el-button>
          <el-button v-if="hasPermission('unmcontactus:cecUnmContactUs:del')" type="text"  icon="el-icon-delete" size="small" @click="del(scope.row.id)">删除</el-button>
        </template>
              </vxe-column>-->
            </vxe-table>
          </el-tab-pane>
        </el-tabs>
        <vxe-pager
          background
          size="small"
          :current-page="tablePage.currentPage"
          :page-size="tablePage.pageSize"
          :total="tablePage.total"
          :page-sizes="[10, 20, 100, 1000, {label: '全量数据', value: 1000000}]"
          :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
          @page-change="currentChangeHandle"
        ></vxe-pager>
      </div>
    </div>
    <!-- 弹窗, 新增 / 修改 -->
    <CecUnmContactUsForm ref="cecUnmContactUsForm" @refreshDataList="refreshList"></CecUnmContactUsForm>
  </div>
</template>

<script>
  import CecUnmContactUsForm from './CecUnmContactUsForm'
  import cecUnmContactUsService from '@/api/unmcontactus/cecUnmContactUsService'
  export default {
    data () {
      return {
        searchForm: {
          firstName: '',
          lastName: '',
          email: '',
          message: '',
          type: '1',
          projectType: '',
          projectStartTime: '',
          projectBudget: '',
          isRead: '',
          status: '',
          statusIn: ['0', '1', '2']
        },
        dataList: [],
        tablePage: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
          orders: [{ column: 'create_date', asc: false }]
        },
        loading: false,
        isReadList: [
          {label: '未读', value: '0'},
          {label: '已读', value: '1'}
        ],
        activeName: '2'
      }
    },
    components: {
      CecUnmContactUsForm
    },
    activated () {
      this.activeName = '2'
      this.searchForm.type = '2'
      this.refreshList()
    },
    methods: {
      handleClick (e) {
        // this.resetSearch()
        this.$refs.searchForm.resetFields()
        this.dataList = []
        this.tablePage = {
          total: 0,
          currentPage: 1,
          pageSize: 10,
          orders: [{ column: 'create_date', asc: false }]
        }
        this.searchForm.type = this.activeName
        this.refreshList()
      },
      // 获取数据列表
      refreshList () {
        this.loading = true
        cecUnmContactUsService.list({
          'current': this.tablePage.currentPage,
          'size': this.tablePage.pageSize,
          'orders': this.tablePage.orders,
          ...this.searchForm
        }).then(({data}) => {
          this.dataList = data.records
          this.tablePage.total = data.total
          this.loading = false
        })
      },
      // 当前页
      currentChangeHandle ({ currentPage, pageSize }) {
        this.tablePage.currentPage = currentPage
        this.tablePage.pageSize = pageSize
        this.refreshList()
      },
      // 排序
      sortChangeHandle (obj) {
        this.tablePage.orders = []
        if (obj.order != null) {
          this.tablePage.orders = [{ column: obj.column.sortBy || this.$utils.toLine(obj.property), asc: obj.order === 'asc' }]
        } else {
          this.tablePage.orders = [{ column: 'create_date', asc: false }]
        }
        this.refreshList()
      },
      // 新增
      add () {
        this.$refs.cecUnmContactUsForm.init('add', '')
      },
      // 修改
      edit (id) {
        id = id || this.$refs.cecUnmContactUsTable.getCheckboxRecords().map(item => {
          return item.id
        })[0]
        this.$refs.cecUnmContactUsForm.init('edit', id)
      },
      // 查看
      view (id, type) {
        this.$refs.cecUnmContactUsForm.init('view', {id: id, type: type})
      },
      // 删除
      del (type) {
        let ids = ''
        if (type === '2') {
          ids = this.$refs.cecUnmContactUsTable2.getCheckboxRecords().map(item => {
            return item.id
          }).join(',')
        } else {
          ids = this.$refs.cecUnmContactUsTable.getCheckboxRecords().map(item => {
            return item.id
          }).join(',')
        }
        this.$confirm(`确定删除所选项吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          cecUnmContactUsService.delete(ids).then(({data}) => {
            this.$message.success(data)
            this.refreshList()
            this.loading = false
          })
        })
      },
      // 下载模板
      downloadTpl () {
        this.loading = true
        cecUnmContactUsService.exportTemplate().then(({data}) => {
    // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, '请假表单导入模板')
          this.loading = false
        }).catch(function (err) {
          this.loading = false
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      // 自定义服务端导入
      importMethod ({ file }) {
      // 处理表单
        const formBody = new FormData()
        formBody.append('file', file)
        this.loading = true
        cecUnmContactUsService.importExcel(formBody).then(({data}) => {
          this.$message.success({
            dangerouslyUseHTMLString: true,
            message: data
          })
          this.refreshList()
        })
      },
      // 自定义服务端导出
      exportMethod ({ options }) {
      // 传给服务端的参数
        const params = {
          current: this.tablePage.currentPage,
          size: this.tablePage.pageSize,
          orders: this.tablePage.orders,
          ...this.searchForm,
          filename: options.filename,
          sheetName: options.sheetName,
          isHeader: options.isHeader,
          original: options.original,
          mode: options.mode,
          selectIds: options.mode === 'selected' ? options.data.map((item) => item.id) : [],
          exportFields: options.columns.map((column) => column.property && column.property.split('.')[0])
        }
        this.loading = true
        return cecUnmContactUsService.exportExcel(params).then(({data}) => {
      // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, options.filename)
          this.loading = false
        }).catch(function (err) {
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      resetSearch () {
        this.$refs.searchForm.resetFields()
        this.refreshList()
      }
    }
  }
</script>

